// extracted by mini-css-extract-plugin
export default {"replaceEndlineWithLineBreaks":"UserView_replaceEndlineWithLineBreaks__1K+Ax"};